/* c8 ignore start */
import cards from "./cards";

export default {
  cards,
};
/* c8 ignore end */
